<template>
  <v-container class="px-0">
    <v-tab-item class="pb-12">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('partidaTabAvailable', $event)" />

        <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
        <v-row class="mx-auto">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required|max:255">
              <v-text-field
                id="titulo-conciliacao"
                v-model="titulo"
                label="Título"
                outlined
                :error-messages="errors"
                class="my-0"
              />
            </validation-provider>
          </v-col>
        </v-row>

        <v-row class="mx-auto">
          <v-col cols="12" sm="3">
            <validation-provider id="tuc-selecionada-conciliacao" v-slot="{ errors }" rules="required">
              <v-select
                v-model="tucSelecionada"
                class="my-0"
                outlined
                :items="tucsList"
                label="TUC"
                :error-messages="errors"
                @change="setPrioridades($event)"
              />
            </validation-provider>
          </v-col>

          <v-col cols="11" sm="8">
            <validation-provider id="flexibilidade-conciliacao" v-slot="{ errors }" rules="required">
              <v-select
                v-model="flexibilidade"
                class="my-0"
                outlined
                :items="['Flexível', 'Rígida', 'Parcial']"
                label="Flexibilidade"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>

          <v-col cols="1" class="pl-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  id="dialog-flexibilidade-conciliacao"
                  v-bind="attrs"
                  size="28"
                  class="pt-4"
                  v-on="on"
                  @click.close="dialogFlexibilidade = true"
                >
                  mdi-progress-question
                </v-icon>
              </template>
              <span>Clique aqui para obter um informativo sobre as diferenças das flexibilidades</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-row class="mx-auto">
          <v-col cols="12">
            <v-expansion-panels v-model="panels" accordion multiple>
              <v-expansion-panel id="conciliacao-editar-prioridades">
                <v-expansion-panel-header style="font-weight: 300; font-size: 15px">Editar Prioridade</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify="center" align="center" no-gutters style="font-size: 14px; text-align: center">
                    <v-col sm="4" cols="12">
                      <p :style="[rodadasOrdemRelevancia ? { color: 'rgba(0, 0, 0, 0.3)' } : { color: '#E5502C' }]">
                        Ordenação Padrão
                      </p>
                    </v-col>

                    <v-col sm="1" cols="4">
                      <v-spacer />
                    </v-col>
                    <v-col cols="1">
                      <v-switch
                        v-model="rodadasOrdemRelevancia"
                        class="mb-5 mt-0 switch-tipo-ordenacao"
                        :loading="true"
                        :hide-details="true"
                      />
                    </v-col>
                    <v-col sm="1" cols="4">
                      <v-spacer />
                    </v-col>

                    <v-col sm="4" cols="12">
                      <p :style="[rodadasOrdemRelevancia ? { color: '#E5502C' } : { color: 'rgba(0, 0, 0, 0.3)' }]">
                        Ordenação por Relevância
                      </p>
                    </v-col>
                  </v-row>

                  <draggable v-model="atributosList" v-bind="dragOptions" @end="setPrioridades(undefined)">
                    <v-checkbox
                      v-for="atributo in atributosList"
                      :key="atributo"
                      v-model="prioridades"
                      dense
                      multiple
                      hide-details
                      :error="prioridadesLimitIsOver"
                      class="d-inline-flex mx-1 my-0 pa-0 shrink"
                      :label="atributo"
                      :value="atributo"
                      @change="setPrioridades(undefined)"
                    />
                  </draggable>

                  <validation-provider v-if="prioridadesLimitIsOver" name="limitePrioridades" rules="required">
                    <input type="hidden" />
                    <div class="ml-2 mt-2 warning--text">Limite de prioridades alcançado</div>
                  </validation-provider>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel id="conciliacao-editar-rodadas">
                <v-expansion-panel-header style="font-weight: 300; font-size: 15px">
                  Editar Rodadas [{{ rodadas.length }}]
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <rodadas-conciliacoes
                    v-model="rodadas"
                    :atributos-list="['TUC', ...atributosList]"
                    :tipo-conciliacao="tipoConciliacao"
                    :page.sync="rodadasPage"
                    action-btns-sm="5"
                    atributos-sm="3"
                    atributos-cols="12"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row class="mx-auto">
          <v-col id="conciliacao-atributos-coringa" cols="12" class="pl-2">
            <div class="d-inline-flex">
              <v-checkbox v-model="atributosCoringa" class="my-0" label="Habilitar Atributos Coringa?" />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    id="conciliacao-atributos-coringa-help"
                    v-bind="attrs"
                    class="mb-5 ml-1"
                    v-on="on"
                    @click="dialogAtributosCoringa = true"
                  >
                    mdi-progress-question
                  </v-icon>
                </template>
                <span>Clique aqui para obter um informativo sobre habilitar atributos coringa</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>

    <template v-for="(campos, key) in partidaReferencia">
      <v-tab-item :key="key" class="pb-12">
        <validation-observer v-slot="{ valid }">
          <validation-helper
            :interceptor="valid"
            @isValid="$emit(key == 'partida' ? 'referenciaTabAvailable' : 'estimativaTempoTabAvailable', $event)"
          />

          <div :id="`conciliacao-base-de-${key}`">
            <v-row align="center" class="mx-auto">
              <v-col cols="12">
                <validation-provider :id="`selecionar-origem-${key}-conciliacao`" v-slot="{ errors }" rules="required">
                  <v-select
                    v-model="campos.origem"
                    outlined
                    :items="['Arquivo', 'Consulta']"
                    :label="key == 'partida' ? 'Origem Base de Partida' : 'Origem Base de Referência'"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <v-row align="center" class="mx-auto">
              <v-col v-show="campos.origem" cols="12" class="mb-4">
                <v-alert dense outlined type="info" color="blue" class="pa-2">
                  <div v-if="campos.origem == 'Consulta'">
                    <template v-if="key == 'partida'">
                      A consulta selecionada deve conter os campos
                      <b>ID, ODI, TI, TUC, A1, A2, A3, A4, A5, A6</b>
                      ,
                      <b>QTD</b>
                      ,
                      <b>DATA</b>
                      e
                      <b>PERIODO</b>
                      .
                    </template>
                    <template v-else>
                      A consulta selecionada deve conter os campos
                      <b>ID, ODI, TI, TUC, A1, A2, A3, A4, A5, A6</b>
                      ,
                      <b>QTD</b>
                      ,
                      <b>DATA</b>
                      ,
                      <b>DATA CONEXÃO</b>
                      e
                      <b>PERIODO</b>
                      .
                    </template>
                    <br />
                    Obs: O campo
                    <b>QTD</b>
                    pode conter os nome
                    <b>QTD Somatório</b>
                    ,
                    <b>QTD_MCPSE Somatório</b>
                    ,
                    <b>QTD_MCPSE</b>
                    ou
                    <b>QTD</b>
                    para ser validado.
                    <br />
                    Obs: O campo
                    <b>ID</b>
                    pode conter os nomes
                    <b>ID</b>
                    ,
                    <b>COD_ID</b>
                    ,
                    <b>IMOBILIZADO</b>
                    ou
                    <b>SUBNÚMERO</b>
                    para ser validado.
                    <br />
                    Obs: O campo
                    <b>DATA</b>
                    pode conter os nomes
                    <b>DATA</b>
                    ou
                    <b>DATA IMOBILIZAÇÃO</b>
                    para ser validado.
                    <template v-if="key == 'referencia'">
                      <br />
                      Obs: O campo
                      <b>DATA CONEXÃO</b>
                      pode conter os nomes
                      <b>DATA CONEXÃO</b>
                      ,
                      <b>DATA_CONEXAO</b>
                      ou
                      <b>DATA CONEXAO</b>
                      para ser validado.
                    </template>
                    <br />
                    Obs: O campo
                    <b>PERIODO</b>
                    pode conter os nomes
                    <b>INCREMENTAL_BLINDADA</b>
                    ,
                    <b>PERIODO</b>
                    ou
                    <b>PERÍODO</b>
                    para ser validado.
                  </div>

                  <div v-if="campos.origem == 'Arquivo'">
                    <template v-if="key == 'partida'">
                      O arquivo selecionado deve conter os campos
                      <b>ID, ODI, TI, TUC, A1, A2, A3, A4, A5, A6</b>
                      ,
                      <b>QTD</b>
                      ,
                      <b>DATA</b>
                      , e
                      <b>PERIODO</b>
                      .
                    </template>
                    <template v-else>
                      O arquivo selecionado deve conter os campos
                      <b>ID, ODI, TI, TUC, A1, A2, A3, A4, A5, A6</b>
                      ,
                      <b>QTD</b>
                      ,
                      <b>DATA</b>
                      ,
                      <b>DATA CONEXÃO</b>
                      e
                      <b>PERIODO</b>
                      .
                    </template>
                    <br />
                    Obs: O campo
                    <b>QTD</b>
                    pode conter os nome
                    <b>QTD Somatório</b>
                    ,
                    <b>QTD_MCPSE</b>
                    ,
                    <b>QTD_MCPSE Somatório</b>
                    ou
                    <b>QTD</b>
                    para ser validado.
                    <br />
                    Obs: O campo
                    <b>ID</b>
                    pode conter os nomes
                    <b>ID</b>
                    ,
                    <b>COD_ID</b>
                    ,
                    <b>IMOBILIZADO</b>
                    ,
                    <b>EI</b>
                    ou
                    <b>SUBNÚMERO</b>
                    para ser validado.
                    <br />
                    Obs: O campo
                    <b>DATA</b>
                    pode conter os nomes
                    <b>DATA</b>
                    ou
                    <b>DATA IMOBILIZAÇÃO</b>
                    para ser validado.
                    <template v-if="key == 'referencia'">
                      <br />
                      Obs: O campo
                      <b>DATA CONEXÃO</b>
                      pode conter os nomes
                      <b>DATA CONEXÃO</b>
                      ,
                      <b>DATA_CONEXAO</b>
                      ou
                      <b>DATA CONEXAO</b>
                      para ser validado.
                    </template>
                    <br />
                    Obs: O campo
                    <b>PERIODO</b>
                    pode conter os nomes
                    <b>PERIODO</b>
                    ou
                    <b>PERÍODO</b>
                    para ser validado.
                    <br />
                    <a href="javascript:void(0)" @click="getArquivoModelo()">Clique aqui</a>
                    para baixar o arquivo modelo.
                  </div>
                </v-alert>
              </v-col>
            </v-row>

            <v-row v-if="campos.origem == 'Consulta'" align="center" class="mx-auto">
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    :id="`selecionar-consulta-${key}-conciliacao`"
                    v-model="campos.consultaNome"
                    label="Consulta"
                    placeholder="Selecione uma consulta"
                    readonly
                    outlined
                    :success="campos.headerValido"
                    :error-messages="errors"
                    @focus.close="relatoriosDialog = true"
                  />
                </validation-provider>
              </v-col>

              <validation-provider rules="required">
                <input type="hidden" :name="`valida-header-consulta-${key}`" :value="campos.headerValido ? 'OK' : ''" />
              </validation-provider>
            </v-row>

            <v-row v-if="campos.origem == 'Arquivo'" align="center" class="mx-auto">
              <v-col cols="12" class="pl-2">
                <validation-provider :id="`selecionar-arquivo-${key}-conciliacao`" v-slot="{ errors }" rules="required">
                  <v-file-input
                    v-model="campos.arquivo"
                    label="Arquivo CSV"
                    placeholder="Selecione um arquivo CSV"
                    outlined
                    accept=".csv, .zip"
                    :show-size="!campos.fakeFile"
                    truncate-length="30"
                    :loading="campos.uploading"
                    loader-height="4"
                    :success="campos.arquivoId && campos.arquivo && campos.headerValido ? true : false"
                    :error-messages="errors"
                    @change="uploadNewFile(campos)"
                  />
                </validation-provider>

                <validation-provider rules="required">
                  <input
                    type="hidden"
                    :name="`valida-upload-${key}`"
                    :value="campos.arquivoId && campos.headerValido ? 'OK' : ''"
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <parametros-arquivo-csv
              v-if="campos.origem == 'Arquivo'"
              :id="`campos-arquivo-${key}-conciliacao`"
              :delimitador.sync="campos.delimitador"
              :involucro.sync="campos.involucro"
              :escape.sync="campos.escape"
            />
          </div>
        </validation-observer>
      </v-tab-item>
    </template>

    <v-tab-item class="pb-12">
      <tempo-estimado-conciliacao-alert :tempo-estimado="tempoEstimado" :loading="loading" />
    </v-tab-item>

    <general-relatorios-selector :activated.sync="relatoriosDialog" @selected="setRelatorio($event)" />
    <dialog-flexibilidade :activated.sync="dialogFlexibilidade" />
    <dialog-atributos-coringa :activated.sync="dialogAtributosCoringa" />
  </v-container>
</template>

<script>
  import conciliacoesWizardTabsMixins from '@/mixins/conciliacoes/conciliacoesWizardTabsMixins.js';
  import randomString from '@/utils/generateRandomString';

  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      GeneralRelatoriosSelector: () => import('@/components/general/selectors/GeneralRelatoriosSelector.vue'),
      draggable: () => import('vuedraggable'),
      RodadasConciliacoes: () => import('@/components/conciliacoes/RodadasConciliacoes.vue'),
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue'),
      DialogFlexibilidade: () => import('@/components/conciliacoes/DialogFlexibilidade.vue'),
      DialogAtributosCoringa: () => import('@/components/conciliacoes/DialogAtributosCoringa.vue'),
      TempoEstimadoConciliacaoAlert: () => import('@/components/conciliacoes/TempoEstimadoConciliacaoAlert.vue')
    },

    mixins: [conciliacoesWizardTabsMixins],

    props: {},

    emits: ['partidaTabAvailable'],

    data() {
      return {
        tipoConciliacao: 'Express',
        rodadasPage: 1,
        rodadasOrdemRelevancia: false
      };
    },

    computed: {
      dragOptions() {
        return {
          animation: 300,
          ghostClass: 'ghost'
        };
      },
      rodadasPerPage() {
        return this.rodadas.slice(0, this.rodadasPage * 10);
      },
      prioridadesLimitIsOver() {
        return this.prioridades.length >= 16;
      }
    },

    mounted() {
      if (!this.$route.params.id) {
        this.getCsvCamposPadroes();
        this.criarRodadas(this.prioridades);
      } else {
        this.fillFields();
      }
    },

    methods: {
      setPrioridades(tucSelecionada = undefined) {
        const prioridadePorTuc = {
          125: ['ODI', 'A1', 'A2', 'A4', 'A3', 'TI'],
          135: ['ODI', 'A2', 'A4', 'A3', 'A1', 'A5'],
          160: ['ODI', 'A1', 'A2', 'A4', 'A3', 'A5', 'A6', 'TI'],
          190: ['TI', 'A3', 'A1', 'A2', 'A4', 'A5'],
          210: ['ODI', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'TI'],
          255: ['A1', 'A3', 'A2', 'A4', 'A5'],
          295: ['ODI', 'TI', 'A1', 'A5', 'A6', 'A2', 'A4', 'A3'],
          330: ['ODI', 'A1', 'A2', 'A3', 'A4'],
          340: ['ODI', 'TI', 'A2', 'A5', 'A4', 'A3', 'A1', 'A6'],
          345: ['ODI', 'A2', 'A4', 'A3', 'A5', 'A6', 'TI'],
          395: ['ODI', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6'],
          565: ['TI', 'A4', 'A5', 'A3', 'A1', 'A2', 'A6'],
          570: ['ODI', 'A2', 'A4', 'A3', 'A5', 'TI', 'A1', 'A6'],
          575: ['ODI', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6'],
          580: ['ODI', 'A4', 'A5', 'A1', 'A3', 'A2', 'A6']
        };

        if (this.prioridadesLimitIsOver) {
          return;
        }

        if (tucSelecionada != undefined) {
          this.prioridades = ['TUC', ...prioridadePorTuc[this.tucSelecionada]]; // TUC é fixamente o primeiro na prioridade
          this.atributosList = [
            ...this.prioridades.filter((atrib) => atrib != 'TUC'),
            ...this.atributosList.filter((atrib) => !this.prioridades.includes(atrib))
          ];
        } else {
          this.prioridades = [
            // TUC é fixamente o primeiro na prioridade
            'TUC',
            ...this.atributosList.filter((atrib) => this.prioridades.includes(atrib))
          ];
        }

        this.criarRodadas(this.prioridades);
      },
      calculaPeso(rodada, prioridade) {
        let peso = rodada.length * 100;

        rodada.forEach((atrib) => {
          peso += prioridade[atrib];
        });

        return peso;
      },
      criarRodadas(listaColunas) {
        let j = 0;
        let prioridade = {};
        listaColunas.forEach((atrib) => {
          prioridade[atrib] = atrib == 'TUC' ? 0 : listaColunas.length - j;
          j++;
        });

        let aux = [];
        let tam = listaColunas.length;

        let start = 2 ** (tam - 1) - 1;
        let stop = -1;
        let step = -1;

        for (var i = start; i > stop; i += step) {
          let b = (Number(i) >>> 0).toString(2);
          b = '1'.padEnd(tam - b.length, '0') + b;

          let rodada = [];
          for (var k = 0; k < b.length; k++) {
            if (b[k] == 1) {
              rodada.push(listaColunas[k]);
            }
          }

          let rodadaPeso = {
            rodada: rodada,
            peso: -this.calculaPeso(rodada, prioridade)
          };

          aux.push(rodadaPeso);
        }

        aux.sort((val1, val2) => {
          if (val1.peso > val2.peso) return 1;
          else if (val1.peso == val2.peso) return 0;
          return -1;
        });

        // Volta a exibir no max. 10 rodadas antes de gerar as novas rodadas
        this.rodadasPage = 1;

        this.rodadas = aux.map((aux) => {
          return { valores: aux.rodada, key: randomString(20) };
        });
        if (this.rodadasOrdemRelevancia === true) {
          this.ordernarRodadasPorRelevancia();
        }
      },
      ordernarRodadasPorRelevancia() {
        const tam = this.prioridades.length;
        let newPrioridades = {};

        this.prioridades.forEach((atributo, index) => {
          newPrioridades[atributo] = tam - index;
        });
        newPrioridades.TUC = tam;

        let dictRodada = {};
        let lista = [];
        this.rodadas.forEach((rodada, indexRodada) => {
          const chaveRodada = this.convertRodadaPorRelevancia(newPrioridades, rodada.valores);

          dictRodada[chaveRodada] = indexRodada;
          lista.push(chaveRodada);
        });

        lista.sort().reverse();

        let newRodadas = [];
        lista.forEach((chaveDict) => {
          const indexRodada = dictRodada[chaveDict];
          newRodadas.push(this.rodadas[indexRodada]);
        });

        this.rodadas = newRodadas;
      },
      convertRodadaPorRelevancia(newPrioridades, atributosRodada) {
        let val = '';

        for (let index = 0; index < this.prioridades.length; index++) {
          let aux = '';
          if (index >= atributosRodada.length) {
            aux = 'A';
          } else {
            aux = String.fromCharCode(newPrioridades[atributosRodada[index]] + 66);
          }

          val += aux;
        }

        return val;
      }
    },

    watch: {
      conciliacao() {
        this.fillFields();
      },
      panels(newVal, oldVal) {
        // Caso o usuario feche o painel 'Editar Rodadas' a paginação volta a exibir 10 elementos no max.
        if (newVal != 1 && oldVal == 1) {
          this.rodadasPage = 1;
        }
      },
      rodadasOrdemRelevancia() {
        this.criarRodadas(this.prioridades);
      },
      tab(newTab) {
        if (newTab === 3) {
          this.getTempoEstimado();
        }
      }
    }
  };
</script>

<style>
  .ghost {
    opacity: 0.5;
  }
  .switch-tipo-ordenacao .v-input--selection-controls__input .v-input--switch__thumb {
    color: #e5502c !important;
  }
</style>
